// src/features/simulators/dispenser/components/DispenserSimulator.tsx

import React, { useState, useCallback } from 'react';
import { useTranslate } from 'react-admin';
import { VpnKey as DispenserIcon } from '@mui/icons-material';
import { SimulatorWizard } from '../../shared/components/SimulatorWizard';
import { useSimulatorWizard } from '../../shared/hooks/useSimulatorWizard';
import { DispenserConfigForm } from './DispenserConfigForm';
import { useDispenserSimulation } from '../hooks/useDispenserSimulation';
import { QRCodeType, CheckInSource } from '../types';
import type { DispenserConfigValues } from './DispenserConfigForm';

export const DispenserSimulator: React.FC = () => {
  const translate = useTranslate();
  const wizard = useSimulatorWizard({ deviceType: 'Dispenser', channel: 'Dispenser' });
  const { simulate } = useDispenserSimulation();

  const [config, setConfig] = useState<DispenserConfigValues>({
    qrCodeType: QRCodeType.ROOM_NUMBER,
    checkInSource: CheckInSource.PRE_CHECKIN,
    performPMSCheckIn: false,
    reservationNumber: '',
    autoGenerateReservation: true,
  });

  const handleRun = useCallback(() => {
    wizard.runSimulation(async (client, addLog) => {
      return simulate(client, addLog, wizard.deviceId, config);
    });
  }, [wizard, simulate, config]);

  return (
    <SimulatorWizard
      title={translate('resources.simulators.dispenser.title')}
      subtitle={translate('resources.simulators.dispenser.description')}
      icon={<DispenserIcon />}
      wizard={wizard}
      deviceType="Dispenser"
      channel="Dispenser"
      configForm={
        <DispenserConfigForm
          values={config}
          onChange={setConfig}
        />
      }
      onRun={handleRun}
    />
  );
};

export default DispenserSimulator;
